import {
  useState,
  useEffect,
} from "react";
import { Col, Row, Spinner, Table } from "react-bootstrap";
import {
  DatatableWrapper,
  Pagination,
  TableBody,
  TableHeader,
} from "react-bs-datatable";
import fuziElevatorsApi from "../../api/fuziElevatorsApi";
import { Link } from "react-router-dom";
import { ROUTES } from "../../constants/webRouting";

const RelatedListOrder = ({ parent, refreshList, table }) => {

  const [body, setBody] = useState([]);
  const [headers, setHeaders] = useState([
    {title:'Order',prop:"offer_name_label",
      cell:(row)=>(
        <Link to={`${ROUTES.ORDER.LIST}/${row.id}`}>{row.offer_name_label}</Link>
      )
    },
    {title:'Lead Name',prop:"lead_name",
      cell:(row)=>(
        <Link to={`${ROUTES.LEAD.LIST}/${row.lead_id}`}>{row.lead_name}</Link>
      )
    },
    {title:'Phone',prop:"phone"},
    {title:'Email',prop:"email"},
    {title:'Assign Staff',prop:"owner_name",
      cell:(row)=>(
        <Link to={`${ROUTES.USER.LIST}/${row.owner_id}`}>{row.owner_name}</Link>
      )
    },
  ]);

  useEffect(() => {
    // console.log('parent',parent);
    init();
  }, []);

  useEffect(() => {
    init();
  }, [refreshList]);

  async function init() {
    let result = await fuziElevatorsApi.fetchOrdersByOfferId(parent.id);

    if (result && result?.length > 0) {
      setBody(result);
    } else {
      setBody([]);
    }
  }

  return (
    <>
      <DatatableWrapper
        body={body}
        headers={headers}
        paginationOptionsProps={{
          initialState: {
            rowsPerPage: 5,
          },
        }}
      >
        <Row className="mb-4">
          <Col
            xs={12}
            sm={6}
            lg={4}
            className="d-flex flex-col justify-content-start align-items-start"
          ></Col>
          <Col
            xs={12}
            sm={6}
            lg={4}
            className="d-flex flex-col justify-content-start align-items-start"
          ></Col>
          <Col
            xs={12}
            sm={6}
            lg={4}
            className="d-flex flex-col justify-content-end align-items-end"
          ></Col>
        </Row>
        <Table striped className="related-list-table shadow rounded sm " responsive={true}>
          <TableHeader classes={{ th: 'bg-custom text-white' }} />
          {
            (body && Array.isArray(body)) ?
              <TableBody />
              :
              <tbody className="">
                <tr>
                  <td colSpan={100} align="center">
                    <div>
                      <Spinner />
                    </div>
                  </td>
                </tr>
              </tbody>
          }
        </Table>
        <Pagination classes={{ buttonGroup: "btn-custom", button: "bg-custom border-white" }} />
      </DatatableWrapper>
    </>
  );
};

export default RelatedListOrder;
